import React, { Component } from 'react';

class QuizDescription extends Component {
    render() {
        let quiz = this.props.quiz;
        let image = quiz.image || null;
        let htmlDescription = function () { return { __html: quiz.introduction }; };

        return (
            <section className="overviewSection">
                {(image && image.filePath)?
                <div className="imageWrapper">
                    <img src={image.filePath} alt={image.altText} />
                </div>:null}
                <h1 className="overviewTitle">Welcome to Dynamic Health’s assessment questionnaire</h1>
                <div className="description" dangerouslySetInnerHTML={htmlDescription()} />
                <button onClick={this.props.showQuizQuestion}>Begin Questionnaires</button>
            </section>
        );
    };
}

export default QuizDescription;